module.exports = __webpack_public_path__ + "img/A1_HQ02.206d1c23.jpg";